import { Text } from "@chakra-ui/layout";
import "../Segmentation Project/segmentation-project.css";
import { Box } from "@chakra-ui/react";
import UploadImage from "./uploadImage";

function Segmentation() {
  return (
    <Box id='segmentation'>
      <Box textAlign='center' width='100%'>
        <Text fontSize={{ base: "18px", md: "25px", lg: "40px" }}>
          ML Driven Healthy Liver Segmentation
        </Text>
        <UploadImage />
      </Box>
    </Box>
  );
}

export default Segmentation;
